import { Box, Container } from "@mui/material";
import { Outlet } from "react-router-dom";
import Sidebar from "./SideBar";
import Topbar from "./Topbar";
import { SIDEBAR_WIDTH } from "../constants";
import { useEffect, useState } from "react";
import { useLazyGetUserQuery } from "../services/auth";
import { getFromStorage } from "../helpers";
import { STORAGE_KEYS } from "../constants/storagekeys";
import { setCredentials } from "../reducers/authSlice";
import secureLocalStorage from "react-secure-storage";
import { useAppDispatch } from "../hooks/store";
import Loader from "../constants/Loader";
import { Navigate, useNavigate } from "react-router-dom";

function MainContainer({ hideHeader = false }: { hideHeader?: boolean }) {
  const dispatch = useAppDispatch();
  const [getUser] = useLazyGetUserQuery();
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  const [mobileOpen, setMobileOpen] = useState(false);

  const handleSidebarToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const getUserDetails = async () => {
    const token = getFromStorage(STORAGE_KEYS.token);

    try {
      const result = await getUser({}).unwrap();
      if (result?.statusCode === 200 && token) {
        // secureLocalStorage.setItem('permissions', JSON.stringify(result?.data?.role_permission));
        secureLocalStorage.setItem("role", result?.data?.role);
        dispatch(
          setCredentials({
            user: result?.data,
            token,
          })
        );
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
    } catch (error) {
      console.log(error);
      setIsAuthenticated(false);
    }
  };

  useEffect(() => {
    getUserDetails();
  }, []);

  useEffect(() => {
    if (isAuthenticated === false) {
      navigate("/", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  // Show loading state while checking auth
  if (isAuthenticated === null) {
    return <Loader isLoad={true} />;
  }

  // Redirect if not authenticated (fallback)
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      {!hideHeader && <Topbar handleSidebarToggle={handleSidebarToggle} />}
      <Sidebar
        mobileOpen={mobileOpen}
        handleSidebarToggle={handleSidebarToggle}
      />
      <Box
        component="main"
        className="main_content"
        sx={{
          marginLeft: "auto",
          width: { lg: `calc(100% - ${SIDEBAR_WIDTH}px)` },
        }}
      >
        <Container className="sub-layout">
          <Outlet />
        </Container>
      </Box>
    </>
  );
}
export default MainContainer;
